import App from '@/models/App'

export default class TrafficShipLiveTracking extends App {
    static get entity() {
        return 'TrafficShipLiveTrackings'
    }

    static fields() {
        return {
            id: this.attr(''),
            trafficShipId: this.attr(''),
            lat: this.attr(0),
            lon: this.attr(0),
            speed: this.attr(0),
            course: this.attr(0),
            navigationalStatus: this.attr(''),
            heading: this.attr(0),
            destination: this.attr(''),
            destPort: this.attr(''),
            descPortUnlocode: this.attr(''),
            depPort: this.attr(''),
            depPortUnlocode: this.attr(''),
            lastPositionEpoch: this.attr(0),
            lastPositionUTC: this.attr(''),
            createdAt: this.attr(''),
            ship: this.attr({}),
            departurePort: this.attr({}),
            destinationPort: this.attr({}),
        }
    }
}
